import { KeyConstructor } from './keyConstructor';
const EXTRA_PROPERTIES_KEY = 'extraProperties';
export const getExtraPropertiesKey = KeyConstructor(EXTRA_PROPERTIES_KEY);
//# sourceMappingURL=properties.keys.js.map